<div *ngIf="imagePath$ | async as imagePath" alt="" [style.background-image]="'url(' + imagePath + ')'" class="avatar">
</div>